export default {
  // The current rendered creative
  creative: null,
  // An error occurred when rotating wallpapers
  error: false,
  // Creative blocked by client
  blockedByClient: false,
  // Can we show ads?
  isAdvertisingEnabled: false,
  // Creative is not visible, we might need to stop rotation, videos, etc.
  isHidden: false,
  // Actual wallpaper provider allows rotation
  isRotationEnabled: false,
  // Rotation can be paused because of wallpaper interations or open panel
  isRotationPaused: false,
  // Current rotation position
  position: 0,
  // ads, editorial, plus...
  providerName: null,
};
